import { useAuth } from "@/context/AuthContext";
import { useFlags } from "@/lib/flags";
import { useAssistant } from "@/lib/assistant";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { MessageCircleQuestion } from "lucide-react";

// Whether the founder's assistant (components/Assistant.jsx) is theirs to open: founders, while documents are open
// (FEATURE_DOCUMENTS)
export function useAssistantShown() {
  const { user } = useAuth() || {};
  const flags = useFlags();
  return user?.role === "owner" && !!flags.documents;
}

// the Assistant button every founder page's header carries (PageHeader), pressed while the drawer is open
export default function AssistantButton() {
  const a = useAssistant();
  return (
    <Button variant="outline" aria-pressed={a.open} onClick={a.toggle} className={cn(a.open && "bg-gr-hover-strong")}
      data-testid="assistant-open"><MessageCircleQuestion />Assistant</Button>
  );
}
